module.exports = __webpack_public_path__ + "src/assets/img/bg1.93e0e649.jpg";